import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

type DroppedFilesContextType = {
  droppedFiles: File[];
  setDroppedFiles: React.Dispatch<React.SetStateAction<File[]>>;
};

const DroppedFilesContext = createContext<DroppedFilesContextType | undefined>(
  undefined
);

export const DroppedFilesProvider = ({ children }: { children: ReactNode }) => {
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);

  return (
    <DroppedFilesContext.Provider value={{ droppedFiles, setDroppedFiles }}>
      {children}
    </DroppedFilesContext.Provider>
  );
};

export const useDroppedFiles = () => {
  const context = useContext(DroppedFilesContext);
  if (!context) {
    throw new Error(
      "useDroppedFiles must be used within a DroppedFilesProvider"
    );
  }
  return context;
};
